import React from 'react';
import TextTruncate from 'react-text-truncate';

// Helpers
import MeetingItemHelpers from 'Shared/model_helpers/MeetingItem.helper';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';

// Styles
import './NotificationMeetingItem.scss';

type Props = {
  meetingItem;
};

const NotificationMeetingItem = ({ meetingItem }: Props) => {
  const bodyRawText = MeetingItemHelpers.getBodyRawText(meetingItem);

  if (!bodyRawText) return null;
  const baseClassName = 'NotificationMeetingItem';

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__icon`}>
        <WpIcon name="check-circle" />
      </div>
      <div className={`${baseClassName}__body`}>
        <TextTruncate line={2} truncateText="…" text={bodyRawText} />
      </div>
    </div>
  );
};

export default NotificationMeetingItem;
